<template>
<div>
    <mu-appbar class="syn-navbar">
        <mu-flat-button
            @click="scanMode('customer')" v-if="scanComponent == 'scan-vouch'"
            class="syn-nav-button" slot="left" icon="arrow_back" :label="back_cus"></mu-flat-button>
        <mu-flat-button
            @click="scanMode('vouch')" v-if="scanComponent == 'scan-barcode'"
            class="syn-nav-button" slot="left" icon="arrow_back" :label="back_des"></mu-flat-button>
        <div v-if="scanComponent == 'scan-customer'" slot="left" class="mu-appbar-title">Récép client</div>
        <div slot="right" style="max-width: 100px; margin-right: 20px;">
            <mu-date-picker hintText="Date" :fullWidth="true" 
                v-model="formData.borddt" 
                okLabel="Ok" cancelLabel="Annuler" autoOk
                format="DD/MM/YYYY" :dateTimeFormat="enDateFormat" 
                @change="getCustomerCb(1)" class="date-bar"></mu-date-picker>
        </div>
        <mu-circular-progress v-show="saveProgress" :size="40" slot="right" style="margin-right: 10px;"></mu-circular-progress>
        <mu-raised-button v-show="!saveProgress" 
            @click="printBar()"
            slot="right" backgroundColor="#ff5722"
            icon="picture_as_pdf" secondary style="min-width:40px; margin-right:10px;"></mu-raised-button>
        <mu-raised-button  @click="saveScan()" slot="right" icon="save" secondary></mu-raised-button>
    </mu-appbar>
    <!-- Tableau -->
    <div class="syn-content">
    <mu-row gutter>
        <mu-col width="100" tablet="20" desktop="20">
            <mu-paper :zDepth="1" >
            <div class="card-toolbar color-black"
                :style="scanZoneStyle" >
                <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">Scans</span>
                <span><mu-flat-button icon="cached" style="min-width: 44px;"></mu-flat-button></span>
            </div>
            <mu-text-field label="Codes barres" class="little-text-input"
                ref="onfoc0"
                @focus="onScan = true" @blur="onScan = false"
                :fullWidth="true" multiLine :rows="5" labelFloat
                v-model="scanZone" lazy ></mu-text-field>
            </mu-paper>
        </mu-col>
        <mu-col width="100" tablet="80" desktop="80">
        <component :is="scanComponent" :cbtable="cbtable" :scanMode="scanMode" :modeData="modeData" :scanControl="scanControl"></component>
        </mu-col>
    </mu-row>
    </div>
</div>
</template>

<script>
import paper from 'muse-components/paper'
import icon       from 'muse-components/icon'
import iconButton from 'muse-components/iconButton'
import appBar     from 'muse-components/appBar'
import flatButton from 'muse-components/flatButton'
import textField  from 'muse-components/textField'
import dialog       from 'muse-components/dialog'
import datePicker   from 'muse-components/datePicker'
import timePicker   from 'muse-components/timePicker'
import raisedButton from 'muse-components/raisedButton'
import circularProgress from 'muse-components/circularProgress'
import {col, row}    from 'muse-components/grid'
import scanCustomer  from './Scan_customer.vue'
import scanVouch     from './Scan_vouch.vue'
import scanBarecode  from './Scan_barcode.vue'
// plugin
import dateLocale from '../plugin/dateLocale';

export default {
    name: 'scan',
    data: function () {
        return {
            scanComponent: 'scan-customer',
            autoProcess: false,
            saveProgress: false,
            timeProgress: false,
            onScan      : false,
            enDateFormat: dateLocale,
            pref: this.$auth.userPref,
            cbtable     : { '0' : { cus_name: 'INCONNU', barcode_scan: 0, barcode_count: 0, recref_count:0 } },
            barCodeList : {},
            scanZone: '',
            modeData: { fk_soc:0, recref: 0 },
            formData: {
                borddt: '', // this.getToday() -1
                order: '', order_by: '', limit: '',
                _method:'GET', _path:'barcode'
            },
            back_cus: 'client', back_des: ''
        }
    },
    computed: {
        scanZoneStyle: function(){
            if( this.onScan ){
                return 'background-color: #c5e1a5; border: 1px solid #edf1f2;'
            } else {
                return 'background-color: #eeeeee; border: 1px solid #edf1f2;'
            }
        }
    },
    methods: {
        getToday(addDay){
            var addDay= addDay || 0
            var today = new Date();
            today.setDate( today.getDate() + addDay )
            var dd    = today.getDate();
            var mm    = today.getMonth()+1; //January is 0!
            var yyyy  = today.getFullYear();
            if(dd<10){ dd='0'+dd; }
            if(mm<10){ mm='0'+mm; }
            return dd+'/'+mm+'/'+yyyy
        },
        getCustomerCb(clean){
            var clean = clean || 0
            this.scanMode('customer') // si refresh on repart sur liste client
            window.axios.post( '/', this.formData )
            .then( (response) => {
                response.data[0] = { cus_name: 'INCONNU', barcode_scan: 0, barcode_count: 0, recref_count:0, vouch: [] }
                this.cbtable     = response.data
                this.$refs['onfoc0'].focus()
                this.barCodeList = {}
                var cus_id, isScan
                for( cus_id in response.data ){
                    let vouch
                    for( vouch in response.data[cus_id]['vouch'] ){
                        let code
                        for( code in response.data[cus_id]['vouch'][vouch]['barcode'] ){
                            isScan = parseInt(response.data[cus_id]['vouch'][vouch]['barcode'][code])
                            this.barCodeList[code]          = {}
                            this.barCodeList[code]['scan']  = isScan
                            this.barCodeList[code]['cus_id']= cus_id
                            this.barCodeList[code]['recref']= vouch
                            this.barCodeList[code]['vouchid'] = response.data[cus_id]['vouch'][vouch]['rowid']
                        }
                    }
                }
            })
        },
        printBar(){
            this.saveProgress = true
            var form = { _method:'GET', _path:'report/1/barcode', borddt:this.formData.borddt, fk_soc:0 }
            if( this.scanComponent == 'scan-vouch' ){
                form.fk_soc = this.modeData.fk_soc 
            }
            window.axios.get( '/', { params: form, responseType:"blob" })
            .then( (response) => {
                this.saveProgress = false
                this.$download(response.data, "barcode.pdf", "application/pdf")
            })
        },
        scanControl(barCode, remove) {
            var remove = remove || false // On ajoute ou on supprime

            if( barCode !== undefined && Object.prototype.toString.call( barCode ) === '[object Array]' ){
                var codeTab = barCode
            } else {
                var codeTab = this.scanZone.split("\n")
            }
            let key, val, customer, recref, codeBare
            for (key = 0; (val = codeTab[key]) !== undefined; key++) {
                if(this.barCodeList.hasOwnProperty(codeTab[key])){
                    recref = this.barCodeList[codeTab[key]]['recref']
                    codeBare = codeTab[key]
                    if( this.barCodeList[ val ]['scan'] <= 0 && this.barCodeList[ val ] !== undefined ){        // Mode Ajout d'un scan
                        customer = this.barCodeList[ val ]['cus_id']
                        if( customer > 0 ){
                            this.barCodeList[ val ]['scan'] = 1
                            this.cbtable[ customer ]['barcode_scan'] += 1
                            this.cbtable[ customer ]['vouch'][recref]['barcode_scan'] += 1
                            this.cbtable[ customer ]['vouch'][recref]['barcode'][codeBare] = 1
                        }
                    } else if ( remove ){                            // Mode suppression d'un scan
                        customer = this.barCodeList[ val ]['cus_id']
                        if( customer > 0 ){
                            this.barCodeList[ val ]['scan'] = -1
                            this.cbtable[ customer ]['barcode_scan'] -= 1
                            this.cbtable[ customer ]['vouch'][recref]['barcode_scan'] -= 1
                            this.cbtable[ customer ]['vouch'][recref]['barcode'][codeBare] = 0
                        }
                    } else {
                        this.barCodeList[ val ]['scan'] += 1
                    }
                } else if ( codeTab[key].length > 0 ){
                    this.cbtable[ 0 ]['barcode_scan'] += 1
                    this.barCodeList[codeTab[key]] = { scan: -2, cus_id: 0 }
                }
            }
            this.scanZone = ''
            // Enregistrement en base
            window.axios.post( '/', { _method:'POST', _path:'barcode', borddt:this.formData.borddt, scan:codeTab } )
            .then( (response) => {
                this.saveProgress = false

            })
        },
        scanMode(mode, id){
            mode = mode || 'customer'
            id   = id   || 0
            if( mode == 'vouch' ){
                this.modeData.fk_soc = ( id !== 0 ) ? id : this.modeData.fk_soc
                this.back_cus    = this.cbtable[ this.modeData.fk_soc ]['cus_name']
            } else if( mode == 'barcode' ){
                this.modeData.recref = ( id !== 0 ) ? id : this.modeData.recref
                this.back_des = this.cbtable[ this.modeData.fk_soc ]['vouch'][this.modeData.recref]['desti']
            } else {
                mode = 'customer'
            }
            this.scanComponent = "scan-" + mode
            this.$refs['onfoc0'].focus()
        },
        saveScan(){
            // Enregistrement en base
            window.axios.post( '/', { _method:'PUT', _path:'barcode', borddt:this.formData.borddt, scan:this.barCodeList } )
            .then( (response) => {
                this.saveProgress = false

            })
        }
    },
    watch: {
        scanZone: function() {
            if( this.timeProgress ){
                clearTimeout(this.timeProgress)
            }
            this.timeProgress = setTimeout( () => {
                this.scanControl()
            }, 1500)
        }
    },
    mounted:function (){
        this.getCustomerCb()
    },
    components: {
        'mu-paper': paper,
        'mu-icon': icon,
        'mu-icon-button': iconButton,
        'mu-appbar': appBar,
        'mu-dialog': dialog,
        'mu-text-field': textField,
        'mu-date-picker': datePicker,
        'mu-time-picker': timePicker,
        'mu-flat-button': flatButton,
        'mu-raised-button': raisedButton,
        'mu-row': row, 'mu-col': col,
        'mu-circular-progress': circularProgress,
        'scan-customer': scanCustomer,
        'scan-vouch': scanVouch,
        'scan-barcode': scanBarecode
    }
}
</script>

<style lang="less">
.appbar-search-field {
    margin-right: 20px;
}
.date-bar {
    width: 100px;
}
@media only screen and (max-width : 768px) {
    .medium-hide {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// Scan.vue?b7bcc1c4